import { render, staticRenderFns } from "./skdu-config-settings.vue?vue&type=template&id=5bd64dea&"
import script from "./skdu-config-settings.vue?vue&type=script&lang=ts&"
export * from "./skdu-config-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports